module.exports = __webpack_public_path__ + "img/icone-fechar.82572c33.svg";